import { render, staticRenderFns } from "./AgregaMedicamento.vue?vue&type=template&id=b3ba0ffc&"
import script from "./AgregaMedicamento.vue?vue&type=script&lang=js&"
export * from "./AgregaMedicamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports